import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import accounting from 'accounting';

import TransitionContainer from '../../components/Transition/TranstionContainer';
import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title as DefaultTitle } from '../../components/Shared/TitleSuccess';
import ThemeContext from '../../utils/theming';

import {
    setOverlayPartnerVisible,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import { formatThousands } from '../../utils/fillDynamicText';
import { ActionTypes, PaymentProviders } from '../../utils/enums';
import { copyFor } from '../../copy/copy';

const Title = styled(DefaultTitle)`
    span {
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 800;
        cursor: pointer;
    }
`;

const TitleComponent = props => (
    <Title
        theme={useContext(ThemeContext)}
        onClick={e => props.setOverlayPartnerVisible(true, e, false)}
        dangerouslySetInnerHTML={{
            __html: copyFor(
                'feedback',
                props.paymentProvider && props.providerSpecificInfo
                    ? 'donatedWithInfo'
                    : 'donated',
                'donation',
                undefined,
                props.paymentProvider && props.providerSpecificInfo
                    ? {
                          user: props.providerSpecificInfo,
                          paymentType: PaymentProviders.find(
                              p => p.id === props.paymentProvider
                          ).displayName,
                          amountFormated: props.amountFormated,
                          partnerName: `<span id="partnerName">${
                              props.partnerName
                          }</span>`
                      }
                    : {
                          amountFormated: props.amountFormated,
                          partnerName: `<span id="partnerName">${
                              props.partnerName
                          }</span>`
                      }
            )
        }}
    />);

TitleComponent.propTypes = {
    amountFormated: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    paymentProvider: PropTypes.number,
    providerSpecificInfo: PropTypes.string,
    setOverlayPartnerVisible: PropTypes.func.isRequired
};

const DonationSuccess = props => (
    <TransitionContainer>
        <ConfirmationCard
            fullwidth
            peopleCount={props.peopleCount}
            thankYouText={props.thankYouText}
            titleComponent={
                <TitleComponent
                    paymentProvider={props.paymentProvider}
                    providerSpecificInfo={props.providerSpecificInfo}
                    amountFormated={props.amountFormated}
                    partnerName={props.partnerName}
                    setOverlayPartnerVisible={props.setOverlayPartnerVisible}
                />
            }
            beforeAdvancing={() => {
                props.setExitingCardProps('donation', props, props.exitingAction);
            }}
            {...props}
        />
    </TransitionContainer>
);

DonationSuccess.propTypes = {
    amountFormated: PropTypes.string.isRequired,
    exitingAction: PropTypes.object.isRequired,
    partnerName: PropTypes.string.isRequired,
    paymentProvider: PropTypes.number,
    peopleCount: PropTypes.string.isRequired,
    providerSpecificInfo: PropTypes.string,
    setExitingCardProps: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    thankYouText: PropTypes.string.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'donation',
            ['/donation/success'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            exitingAction: state.widget.activeAction,
            peopleCount:
                state.donation.completeDonation !== undefined
                    ? formatThousands(state.donation.completeDonation.endUsersCount)
                    : '',
            thankYouText: state.donation.successInfo.feedbackText || '',
            amountFormated: accounting.formatMoney(state.donation.selectedAmount, '$', 0),
            partnerName: state.donation.successInfo.partnerName,
            paymentProvider: state.donation.successInfo.paymentProvider || null,
            providerSpecificInfo: state.donation.successInfo.providerSpecificInfo || null
        };
    },
    { setExitingCardProps, setOverlayPartnerVisible },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.Donation) return true;
            return next === prev;
        }
    }
)(DonationSuccess);
